import ProgressGoalSetting from 'dashboard/templates/views/Patient/Progress/ProgressGoalSetting';

import behaviourChangeGoals from './behaviour-change-goals';
import outcomeGoals from './outcome-goals';

/**
 * Journey progress Goal setting routes
 * @name router.Journey-progress-Goal-setting
 */

export default {
    path: 'goal-setting',
    name: 'PatientRecordProgressGoalSetting',
    component: ProgressGoalSetting,
    redirect: { name: 'ProgressGoalSettingBehaviourChangeGoals' },
    meta: {
        // title: 'Patient Record - Progress - Goal setting',
        title: t => `${t('patient.patientRecord')} - ${t('journeyProgress.progress')} - ${t('journeyProgress.goalSetting')}`,
        loggedInOnly: true,
        inSDMSessionOnly: true,
    },
    children: [
        behaviourChangeGoals,
        outcomeGoals,
    ],
};
